import type { SelectOption } from '@/components/ui/SelectOptions/types';
import type { GetSectorsResponseDTO } from '@/core/dto/sector/get-sectors';

export class GetSectorsMapper {
	constructor(private readonly data: GetSectorsResponseDTO) {}

	toDomain(): SelectOption[] {
		return this.data.map((value) => ({
			value: value.id,
			label: value.name
		}));
	}
}
